import React from 'react';
import { constructUrl } from '../../../utils/UrlConstructor';
import { BuyNowOnce, BuyNowClicked, ProductRemoveFromWishlist } from '../../../utils/Analytics';
import { getBuyNowUrl } from '../../../utils/StoreConfigManager';

import './CartItem.css'

const CartItem = ({ name, price, sku, url, thumbnail, menuTextFontStyle, prefix, removeFromCart }) => {

    const buyButtonClicked = () => {
        BuyNowOnce();
        BuyNowClicked(sku, name);
        window.open(getBuyNowUrl(url), '_blank');
    }

    return (
        <React.Fragment>
            <div className='cart-item-container'>
                {thumbnail && <img className='cart-item-thumbnail' src={constructUrl(thumbnail)} />}
                {!thumbnail && <div className='cart-item-thumbnail'>&nbsp;</div>}
                <div className='cart-item-info' style={menuTextFontStyle}>
                    <span className='cart-product-name' onClick={buyButtonClicked}>{name}</span>
                    {price > 0 && <span>{`${prefix}${price}.00`}</span>}
                </div>
            </div>
            <div className='cart-item-remove' onClick={() => {removeFromCart(sku); ProductRemoveFromWishlist(name, sku);}}>Remove</div>
            <hr className="cart-item-break" />
        </React.Fragment>
    )
}

export default CartItem;
